import { Component, OnInit, QueryList, ViewChild, ViewChildren } from '@angular/core';
import { PlannedRoutesTabComponent, RouteFilterType } from './planned-routes-tab.component';
import { RouteRecommendationService } from '../../../services/route-recommendation.service';
import { ActivatedRoute, Params, Router } from '@angular/router';
import { AlgoTravelPreferencesComponent } from '../../../components/algo-travel-preferences/algo-travel-preferences.component';
import { SupplierInboxType } from '../../../enums/supplier-inbox.type.enum';
import { UserService } from '../../../services';
import { SupplierTravelPreferencesService } from '../../../services/supplier-travel-preferences.service';
import value from '*.json';
import { SelectItem } from 'primeng/api';
import { OrganisationTypeEnum } from '../../../enums/organisation-types';
import { RoutesAnalyticsService } from 'src/app/services/product-analytics/routes-analytics.service';

@Component({
  selector: 'planned-routes',
  templateUrl: './planned-routes.component.html',
  styleUrls: ['./planned-routes.component.scss', './inbox-tabs.scss'],
})
export class PlannedRoutesComponent implements OnInit {
  get activeRouteFilterType(): number {
    return this._activeRouteFilterType;
  }

  set activeRouteFilterType(value: number) {
    this.updateQueryParam('plannedRouteFilterTab', value.toString());
    this._activeRouteFilterType = value;
  }

  private _activeRouteFilterType: number = 0;

  travelPreferencesEnabled = false;

  public plannedRouteSearchTypeOptions: SelectItem[] = [
    { label: 'Available', value: 0 },
    // { label: 'Grabbed', value: 1, count: null },
  ];

  plannedRouteCounts: number[] = [];

  plannedRouteListCount(value: number) {
    return this.plannedRouteCounts[value] ?? 0;
  }

  @ViewChildren(PlannedRoutesTabComponent)
  plannedRouteTabComponents: QueryList<PlannedRoutesTabComponent>;

  public algoTaskScopeDays: number = 1;

  loadingCounts: any;
  isVME: boolean = false;
  isLoading: boolean = true;

  constructor(
    private routeRecService: RouteRecommendationService,
    private router: Router,
    private travelPreferencesService: SupplierTravelPreferencesService,
    private route: ActivatedRoute,
    private userService: UserService,
    private routeAnalyticsService: RoutesAnalyticsService,
  ) {
    this.route.queryParams.subscribe((params: Params) => {
      if (params['plannedRouteFilterTab']) {
        this._activeRouteFilterType = Number(params['plannedRouteFilterTab']);
      }
    });
  }

  async ngOnInit(): Promise<void> {
    try {
      const [taskScope, travelPreferencesEnabled, currentUserOrg] = await Promise.all([
        this.routeRecService.getTaskScope(),
        this.travelPreferencesService.isTravelPreferencesEnabled().catch(() => false),
        this.userService.getCurrentUserOrg(),
      ]);

      this.algoTaskScopeDays = taskScope.lengthInDays;
      this.travelPreferencesEnabled = travelPreferencesEnabled;
      this.isVME = currentUserOrg.organisationTypeId === OrganisationTypeEnum.Engineius;

      this.updateAvailableTabs();
    } catch (error) {
      console.error('Failed to initialise planned-routes data for tab view', error);
    } finally {
      this.isLoading = false;
    }
  }

  updateAvailableTabs(): void {
    if (!this.isVME) {
      this.plannedRouteSearchTypeOptions.push({ label: 'Watched', value: 3 });
      this.plannedRouteSearchTypeOptions.push({ label: 'Hidden', value: 2 });
    }
  }

  updatePlannedRouteCount($event: number, routeFilterType: RouteFilterType): void {
    this.plannedRouteCounts[routeFilterType] = $event;
  }

  plannedRouteConfigExternalRefresh(): void {
    this.plannedRouteTabComponents.forEach((plannedRoutesInstance) => {
      plannedRoutesInstance.externalReload();
    });
  }

  updateQueryParam(paramName: string, paramValue: string) {
    // Get the current route's queryParams
    let queryParams = { ...this.route.snapshot.queryParams };

    // Update or set the query parameter
    queryParams[paramName] = paramValue;

    // Use navigate to update the URL without reloading the page
    this.router.navigate([], {
      relativeTo: this.route,
      queryParams: queryParams,
      // Preserve the existing path parts of the URL.
      queryParamsHandling: 'merge',
    });
  }

  public showPlannedRoutePreferencesDialog: boolean = false;

  @ViewChild(AlgoTravelPreferencesComponent)
  public travelPreferencesComponent!: AlgoTravelPreferencesComponent;

  @ViewChild(PlannedRoutesComponent)
  public plannedRoutesComponent!: PlannedRoutesComponent;

  goToPreferences() {
    this.showPlannedRoutePreferencesDialog = true;
  }

  savePreferences(): void {
    this.travelPreferencesComponent.saveChanges();
    this.showPlannedRoutePreferencesDialog = false;
  }

  protected readonly SupplierInboxType = SupplierInboxType;
}
